import React from 'react';

import PageHeader from '../components/PageHeader';
import TabSection from '../components/TabSection';
import ImageSlider from '../components/ImageSlider';
import Button from '../components/Button';

import policy from '../data/policy';

const PrivacyPolicy = () => {
    return (
        <>
            {/* page header - start */}
            <PageHeader
                title='Aviso legal y condiciones'
                topPaddingTitle='5'
         
            />
            {/* page header - end */}

            {/* tab section - start */}
            <TabSection data={policy} subHeading='' className='tab-section-1' />
            {/* tab section - end */}

            {/* instagram - start */}
            
            <div style={{width:"100%", height:"10px", marginTop:"25rem"}}></div>
            {/* instagram - end */}
        </>
    );
};

export default PrivacyPolicy;
